import { usePlanFeaturesQuery } from '@/hooks/queries/use-plan-features-query';
import type { FeatureFlag } from '@fluenceur/types';

/**
 * Returns whether the active organization has access to the given feature
 * flag. Thin wrapper over `usePlanFeaturesQuery().hasFeature(flag)` so
 * call sites read as `useFeatureFlag(FeatureFlag.PARTNERSHIP_ADS_BOOST)`
 * rather than destructuring the heavier query hook.
 */
export const useFeatureFlag = (flag: FeatureFlag): boolean => {
  const { hasFeature } = usePlanFeaturesQuery();
  return hasFeature(flag);
};

/**
 * The flag together with whether the plan features are still loading. Until
 * they arrive `enabled` reads false, which is indistinguishable from "off": a
 * screen whose copy or controls differ with the flag waits on `isLoading`
 * rather than painting the flag-off version first.
 */
export const useFeatureFlagStatus = (
  flag: FeatureFlag
): { enabled: boolean; isLoading: boolean } => {
  const { hasFeature, isPending } = usePlanFeaturesQuery();
  return { enabled: hasFeature(flag), isLoading: isPending };
};
